import { Injectable } from '@angular/core';
import { User } from '@inera/common';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private user: User;

  constructor() {}

  public getUser() {
    return this.user;
  }

  public setUser(user: User) {
    this.user = user;
  }
}
